export enum MobileAppUploadStatus {
  PENDING = 'pending',
  UPLOADED = 'uploaded',
  EXPIRED = 'expired',
  FAILED = 'failed',
}

export enum MobileAppProvider {
  SAUCE_LABS = 'sauce-labs',
  LOCAL = 'local',
}

export enum MobilePlatform {
  IOS = 'iOS',
  ANDROID = 'Android',
}

export enum MobileScreenOrientation {
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export enum MobileAppCommandName {
  ping = 'ping',
  tap = 'tap',
  scroll = 'scroll',
  screenshot = 'screenshot',
  source = 'source',
  key = 'key',
}

export enum MobileDeviceType {
  REAL = 'real',
  VIRTUAL = 'virtual',
}

export enum MobileDeviceState {
  AVAILABLE = 'AVAILABLE',
  IN_USE = 'IN_USE',
  CLEANING = 'CLEANING',
  MAINTENANCE = 'MAINTENANCE',
  REBOOTING = 'REBOOTING',
  OFFLINE = 'OFFLINE',
}

export enum DeviceWebSocketEvents {
  CONNECT = 'connect',
  FRAMES = 'frames',
  CONNECT_ERROR = 'connect_error',
  ERROR = 'error',
  DISCONNECT = 'disconnect',
  CONNECT_DEVICE = 'connect-device',
  TOUCH_ACTIONS = 'touch-actions',
  KEYBOARD_ACTIONS = 'keyboard-actions',
  SESSION_ERROR = 'session_error',
}

export enum DisconnectReason {
  TRANSPORT_CLOSE = 'transport close',
  TRANSPORT_ERROR = 'transport error',
  PING_TIMEOUT = 'ping timeout',
  IO_SERVER_DISCONNECT = 'io server disconnect',
  IO_CLIENT_DISCONNECT = 'io client disconnect',
}

export enum TouchType {
  DOWN = 'd',
  UP = 'u',
  MOVE = 'm',
}

export enum SessionType {
  RDC = 'rdc',
  APPIUM = 'appium',
}

/**
 * In progress session states: PENDING, OPEN
 */
export enum SessionState {
  PENDING = 'pending',
  OPEN = 'open',
  CLOSED = 'closed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

// mobile integration error code (non-internal errors)
export enum MobileErrorCode {
  APP_DEVICE_TYPE_MISMATCH = 'APP_DEVICE_TYPE_MISMATCH',
  APP_SESSION_ALREADY_RUNNING = 'APP_SESSION_ALREADY_RUNNING',
  APP_SESSION_NOT_FOUND = 'APP_SESSION_NOT_FOUND',
  APP_TARGET_DEVICE_TYPE_MISSING = 'APP_TARGET_DEVICE_TYPE_MISSING',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FILE_SIZE_EXCEEDS_SYSTEM_LIMIT = 'FILE_SIZE_EXCEEDS_SYSTEM_LIMIT',
  FILE_SIZE_IS_ZERO = 'FILE_SIZE_IS_ZERO',
  FILE_TYPE_INVALID = 'FILE_TYPE_INVALID',
  ID_NOT_FOUND = 'ID_NOT_FOUND',
  INVALID_EMULATOR_COMMAND = 'INVALID_EMULATOR_COMMAND',
  IOS_APP_ZIP_FILE_DECOMPRESSION_FAILED = 'IOS_APP_ZIP_FILE_DECOMPRESSION_FAILED',
  IOS_APP_ZIP_FILE_MISSING_APP_FOLDER = 'IOS_APP_ZIP_FILE_MISSING_APP_FOLDER',
  MOBILE_APP_HAS_OPEN_SESSIONS = 'MOBILE_APP_HAS_OPEN_SESSIONS',
  MOBILE_APP_NOT_FOUND = 'MOBILE_APP_NOT_FOUND',
  MOBILE_APP_UPLOAD_FAILED = 'MOBILE_APP_UPLOAD_FAILED', // default app upload error switched from internal errors
  MOBILE_APP_UPLOAD_IS_PENDING = 'MOBILE_APP_UPLOAD_IS_PENDING',
  SAUCE_LABS_API_KEY_VALIDATION_FAILED = 'SAUCE_LABS_API_KEY_VALIDATION_FAILED',
  SAUCE_LABS_FILE_NOT_FOUND = 'SAUCE_LABS_FILE_NOT_FOUND',
  SESSION_CONCURRENCY_LIMITS_EXCEEDED = 'SESSION_CONCURRENCY_LIMITS_EXCEEDED',
  SESSION_START_FAILED = 'SESSION_START_FAILED', // default session start error switched from internal errors
  UNSUPPORTED_DEVICE = 'UNSUPPORTED_DEVICE',
  UNSUPPORTED_PLATFORM = 'UNSUPPORTED_PLATFORM',
  WEBSOCKET_CONNECTION_ERROR = 'WEBSOCKET_CONNECTION_ERROR',
  WEBSOCKET_CONNECTION_REPLACED = 'WEBSOCKET_CONNECTION_REPLACED',
  REAL_DEVICE_NOT_AVAILABLE = 'REAL_DEVICE_NOT_AVAILABLE',
}
